exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".max-width-150 {\n  min-width: 150px;\n}\n", ""]);

// exports
